export default {
sets: `Seturi`,
stats: `Statistici`,
discover: `Descoperi`,
guides: `Ghiduri`,
settings: `Setări`,
unsupportedBrowserBody: `Flashcards nu acceptă acest browser. Descărcați cea mai recentă versiune de Chrome sau Opera sau descărcați aplicația noastră iPhone sau Android`,
unsupportedBrowserTitle: `Browser neacceptat`,
noData: `Nu există date de afișat`,
contactUsTitle: `Ne place să auzim modul în care utilizatorii noștri folosesc aplicația noastră și cum ne putem îmbunătăți. Trimiteți -ne un mesaj cu orice întrebări, cum ar fi cererile de caracteristici sau rapoartele de erori`,
rateAppStore: `Rata în AppStore`,
rateGoogle: `Rata în Google Play`,
close: `Închide`,
shareFriends: `Impartasiti cu prietenii`,
noCardsQ: `Nu aveți carduri flash?`,
noCardsS: `Selectați din colecția noastră pentru a începe`,
suggestSet: `Sugerează set`,
createOwn: `Crează-ți propriul`,
search: `Căutare`,
loading: `Se încarcă`,
words: `Cuvinte`,
downloads: `Descărcări`,
export: `Export`,
import: `Import`,
importing: `Import ... Nu închideți aplicația`,
importPreview: `Import previzualizare`,
howQuizlet: `Cum să importați din Quizlet`,
cards: `Carduri`,
importPreviewStatus: `__ Termenii sunt gata să fie anexați la cardurile ___ existente`,
importPaste: `Lipiți cărțile în textura de mai sus`,
setTotalLimitReached: `Puteți avea doar 3000 de cărți într -un studyset`,
studying: `Studiu`,
learnt: `Învățat`,
mastered: `Stăpânit`,
new: `Nou`,
noTerm: `Fără termen`,
noDef: `Fără definiție`,
cardSaved: `Card salvat`,
reviews: `Recenzii`,
practices: `Practici`,
flashcards: `Carduri flash`,
alerts: `Alerte`,
corrects: `Corectează`,
mistakes: `Greșeli`,
reviewCycle: `Ciclul de revizuire`,
reviewsLeft: `Recenzii rămase`,
lastReview: `Ultima recenzie`,
nextReview: `Următoarea recenzie`,
hideHistory: `Ascunde istoria completă`,
showHistory: `Arată istorie completă`,
strength: `Putere`,
star: `Stea`,
image: `Imagine`,
tag: `Etichetă`,
added: `adăugat`,
removed: `îndepărtat`,
reviewedFrom: `Revizuit de la __`,
notifications: `Notificări`,
reviewedPractice: `Revizuit __ de ___ practică`,
successfully: `cu succes`,
unsuccessfully: `fără succes`,
termUpdated: `Termen actualizat`,
defUpdated: `Definiție actualizată`,
flashcardCreated: `Flashcard creat`,
dropboxImage: `Trebuie să activați Dropbox Sync pentru a adăuga imagini`,
deleteImgConfirm: `Ești sigur că vrei să ștergi această imagine?`,
uploading: `Încărcare`,
save: `salva`,
uploadImageFail: `Nu a reușit să încarce imagine`,
imageUploaded: `Imagine încărcată`,
setNotFound: `Studyset nu a fost găsit!`,
notEnoughCards: `Nu sunt suficiente cărți!`,
of: `__ de ___`,
on: `Pe`,
off: `OFF`,
auto: `Automat`,
manual: `Manual`,
pronounce: `Pronunță`,
practiceCompleted: `Ați finalizat această practică`,
closePractice: `Practică strânsă`,
autoplay: `Redare automata`,
secFlipSecNext: `__ sec flip, ___ sec următor`,
autopronounce: `Autopronunce`,
onlyTerm: `Numai termen`,
onlyDef: `Doar definiție`,
termAndDef: `Termen și definiție`,
savePractice: `Salvați practica?`,
continueLater: `Continuați mai târziu`,
deletePractice: `Ștergeți practica`,
term: `Termen`,
def: `Definiție`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Obiectiv de revizuire`,
dailyGoal: `Obiectiv zilnic`,
edit: `Editați | ×`,
setUp: `Înființat`,
noRecentPractice: `Nu aveți practici recente`,
continueLastReview: `Continuați ultima recenzie`,
dueCards: `Cărți scadente`,
studyNow: `Invata acum`,
newCards: `Cărți noi`,
terms: `termeni`,
defs: `definiții`,
validCardsOf: `Doar __ dintre cardurile ___ selectate pot fi practicate, deoarece celelalte lipsesc termenul sau definiția`,
reviewCards: `Carduri de recenzie`,
customizePractice: `Personalizați practica`,
next: `Următorul`,
iWasRight: `am avut dreptate`,
printProAlert: `Vă rugăm să cumpărați abonament Pro pentru a imprima mai mult de 20 de cărți flash`,
print: `Imprimare`,
printWidth: `Lățimea termenului-def`,
printFont: `Marimea fontului`,
printBorder: `Frontieră`,
printMargin: `Marja paginii`,
printPadding: `Padding de cuvinte`,
preparingFile: `Pregătirea fișierului`,
notificationsBlocked: `Notificările nu sunt activate, activați notificările din setările telefonului dvs.`,
ranOutOfWords: `A rămas fără cărți, reporniți practica pentru a începe din nou`,
ranOutOfWordsShort: `Rămâne fără cuvinte`,
ranOutOfWordsBody: `Deschideți aplicația pentru a programa cuvinte noi`,
proIncreaseNotifications: `Puteți crește notificările totale de la 10 la 50 în versiunea premium.`,
schedule: `Programa`,
frequency: `Frecvență`,
mode: `Mod`,
tM1: `1 minut`,
tM2: `2 minute`,
tM5: `5 minute`,
tM10: `10 minute`,
tM15: `15 minute`,
tM30: `30 minute`,
tH1: `1 oră`,
tH2: `2 ore`,
termPassive: `Termen pasiv`,
termActive: `Termen activ`,
defPassive: `Def pasiv`,
defActive: `Def activ`,
scheduledIn: `Programat în __ min`,
scheduledAlertsProT: `Creșteți alertele programabile cu Pro`,
scheduledAlertsProB: `Puteți crește alertele programate de la 10 la 50 cu pachetul Pro`,
seeFeatures: `Vezi caracteristici`,
defAndTerm: `Definiție și termen`,
termHoldDef: `Termen, reține pentru a dezvălui definiția`,
defHoldTerm: `Definiție, deține pentru a dezvălui termen`,
notificationType: `Tip de notificare`,
copyToClipboard: `Copiați în clipboard`,
enterAuthCode: `Vă rugăm să introduceți codul de autorizare`,
invalidCode: `Cod nevalid furnizat`,
copied: `S -A copiat!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Atingeți pentru a descoperi toate funcțiile premium pentru a învăța mai eficient în ritmul propriu`,
promoBtn: `Descoperiți toate caracteristicile`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Activați Dropbox Sync pentru a vă menține seturile, cardurile flash, etichetele și progresul de rezervă și actualizat pe toate dispozitivele dvs.`,
setDropboxPOn: `Datele dvs. sunt susținute și sincronizate pe dispozitivele dvs.`,
setDropboxBtn: `Sincronizare`,
status: `stare`,
syncNow: `Sincronizați acum`,
contact: `a lua legatura`,
contactUs: `Contactează-ne`,
useFromBrowser: `Folosiți din browser`,
useFromBrowserMsg: `Accesați flashcardsmadesimple.com pe computer și restaurați cardurile și licența, activând Dropbox Sync`,
termsPrivacy: `Termeni și confidențialitate`,
dailyReviewGoal: `Obiectiv de revizuire zilnică`,
numberTerms: `Numărul de termeni`,
selectTerm: `Selectați cu termeni de aluzie`,
selectDef: `Selectați cu Definiție Sugestie`,
pronounceTerm: `Pronunți cu termeni de aluzie`,
pronounceDef: `Pronunță cu indiciu de definiție`,
typeTerm: `Tastați cu termeni de aluzie`,
typeDef: `Tip cu indiciu de definiție`,
quizTypes: `Tipuri de testare preferate`,
spacedRepetition: `Programul de repetare distanțat`,
spacedRepetitionP: `Repetarea distanțată vă permite să stăpâniți cuvintele cu mai puține eforturi, prin distanțarea treptat a timpului de revizuire. Programul implicit este de 1-3-7-15-31 de zile, dar puteți configura și unul personalizat.`,
spacedRepetionScheduleItem: `__ Zile după ___ Recenzie (Ziua ____)`,
atLeastOneSchedule: `Este necesar cel puțin un program`,
revisionLimitReached: `Ați ajuns la numărul maxim de revizuire`,
addReviewSchedule: `Adăugați un nou program de revizuire`,
autoMarkLearnt: `Marca auto aflată după`,
autoMarkMastered: `Marca auto stăpânită după`,
tagManager: `Manager de etichete`,
delete: `Șterge`,
addTag: `Adăugați o nouă etichetă`,
tagDeletionH: `Ștergerea etichetelor`,
tagDeletionP: `Ești sigur că vrei să ștergi această etichetă?`,
cancel: `Anulare`,
daysAfterLastReview: `Zile după ultima recenzie`,
linkDropbox: `Link Dropbox`,
startSync: `Începe sincronizarea`,
starred: `A jucat`,
images: `Imagini`,
tags: `Etichete`,
types: `Tipuri`,
activeDays: `Zile active`,
inactiveDays: `Zile inactive`,
longestStreak: `Cea mai lungă dungă`,
dailyGoalsCompleted: `Obiectivele zilnice finalizate`,
dailyGoalsFailed: `Obiectivele zilnice au eșuat`,
typePairs: `Perechi de tip`,
reviewTypes: `Tipuri de revizuire`,
typePractice: `Tip Practică`,
pronouncePractice: `PRONUNCE PRACTICA`,
selectPractice: `Selectați practica`,
notificationReview: `Revizuirea notificărilor`,
flashcardReview: `Recenzie flashcard`,
studyset: `Studyset`,
enterStudysetName: `Vă rugăm să introduceți un nume pentru studiul dvs.`,
studysetName: `Introduceți numele setului`,
termType: `Tip de termen / Lang`,
defType: `Definiție tip / lang`,
exportCards: `Carduri de export`,
importCards: `Import carduri`,
quiz: `Test`,
showingOutOfCards: `Afișând __ din ___ cărți`,
showingAllCards: `Afișarea tuturor cardurilor, introduceți bara de căutare de mai sus sau atingeți orice etichetă pentru a filtra`,
recording: `Înregistrare`,
downloadSet: `Adăugați la seturile mele`,
addNewCard: `Adăugați card nou`,
saveStudyset: `Salvați setul de studiu`,
studysetDeletionH: `Ștergerea studiului`,
studysetDeletionP: `Sunteți sigur că doriți să ștergeți acest Studyset, acest lucru va șterge și toate cărțile conținute.`,
cardDeletionH: `Ștergerea cardului`,
cardDeletionP: `Sunteți sigur că doriți să ștergeți acest card`,
cardLimitReached: `Puteți avea doar 3000 de cărți într -un studyset`,
limitExceeded: `Limită depășită`,
atLeastTenCards: `Adăugați cel puțin 10 cărți pentru a începe cu practicile`,
searchInAll: `Căutare în toate seturile de studiu`,
noMatch: `Nu se potrivesc`,
atLeastThreeChars: `Introduceți cel puțin 3 caractere pentru a căuta`,
noSets: `Fără seturi`,
startingSync: `Sincronizarea de pornire`,
noSetsP: `Selectați dintre opțiunile de mai jos pentru a începe`,
startingSyncP: `Primim datele dvs. de la Dropbox, acest lucru ar putea dura ceva timp`,
createNewStudyset: `Creați studyset nou`,
restoreFromBackup: `Restaurați din fișierul de rezervă`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Selectați tipul de practică`,
noDueCards: `Nu există încă flash carduri, carduri flash pe care le -ați revizuit înainte vor începe să apară aici după programul de repetare distanțat selectat pentru a vă ajuta să stăpâniți cuvintele cu mai puțin efort și timp`,
noNewCards: `Fără cărți noi de studiat`,
subscriptionH: `Cumpărați Pro pentru a vă bucura de toate caracteristicile și pentru a susține dezvoltarea continuă.`,
buyLifetimePro: `Cumpărați Lifetime Pro pentru __`,
restorePurchase: `RESTABILI CUMPĂRARE`,
termsPrivacyC: `Termeni și Politica de confidențialitate`,
licenceShare: `Dacă ați achiziționat o licență de la un alt dispozitiv, îl puteți partaja cu acest dispozitiv, activând Sincronizarea Dropbox pe ambele dispozitive`,
enterTagName: `Introduceți numele etichetei`,
invalidName: `Nume invalid`,
create: `Crea`,
name: `Nume`,
tagName: `Numele etichetei dvs.`,
color: `Culoare`,
back: `Înapoi`,
rowSeparator: `Separator de rânduri`,
termDefSeparator: `Termen - Separator DEF`,
output: `Ieșire`,
inputCards: `Carduri de intrare`,
review: `Revizuire`,
language: `Limba`,
archiveReversible: `Arhiva (reversibilă din setări)`,
deletePermanent: `Ștergeți (ireversibil)`,
archivedCards: `Cărți arhivate`,
masteredCards: `Cărți stăpâne`,
due: `Datorat`,
reviewed: `Revizuit`,
markReviewed: `Mark revizuit`,
markMastered: `Mark a stăpânit`,
forXYCards: `pentru __ ___ cărți`,
createdAtSortBy: `Data crearii`,
lastReviewedSortBy: `Ultima dată de revizuire`,
reviewCountSortBy: `Numărul de recenzii`,
strengthSortBy: `Putere`,
termSortBy: `Termen alfabetic`,
definitionSortBy: `Def. Alfabetic.`,
ascSortBy: `Ascendent`,
descSortBy: `Descendentă`,
featureSync: `Studiați orice, oriunde, oricând cu carduri flash sincronizate pe toate dispozitivele dvs.`,
featureSpacedrepetition: `Privește -ți progresul general și revino la practicarea a ceea ce ai nevoie pentru a exersa`,
featureNotifications: `Supraîncărcați -vă învățarea fără a deschide chiar aplicația cu notificări flexibile`,
featureFlashcards: `Carduri de flash autoplay atunci când mâinile sau ochii sunt ocupați, dar totuși ai atenție neutilizată`,
featureQuiz: `Potriviți, scrieți -vă, ascultați sau selectați pentru a vă exersa carduri flash`,
featureStats: `Obțineți o perspectivă mai bună asupra cardurilor și rezultatelor dvs. și căutați pe toate seturile dvs. flashcard`,
featureImport: `Nu vom stoca niciodată date despre dvs. și puteți exporta și importa toate datele dvs.`,
featurePrint: `Faceți o învățare făcută prin imprimarea cardurilor dvs. flash și DIY propriul dvs. platformă de studiu`,
splashIntro: `Studiați toate cardurile dvs. flash oriunde în ritmul și stilul dvs.`,
selectSortOrder: `Ordinea de sortare`,
selectSortProp: `Sortează proprietatea`,
applyFilters: `Aplicați filtre`,
selectSetType: `Ce vrei să exersezi?`,
getStarted: `Incepe`,
tapToUnarchive: `Atingeți cardurile pe care doriți să le dezarhivați`,
untitled: `Fără titlu`,
sortHintNew: `Veți vedea cărțile care au fost create mai mult timp în urmă`,
sortHintDue: `Veți vedea cărți care s -au datorat cel mai mult timp`,
sortHintOther: `Veți vedea cărți care nu au fost studiate cel mai mult timp`,
flashcardsWhen: `, când mâinile sau ochii sunt ocupați, chiar în timp ce ascultați muzică / podcast -uri`,
notificationsWhen: `, pentru când sunteți afară și doriți și doriți doar bucăți de studiu rapid`,
quizWhen: `, pentru când puteți acorda atenție deplină pentru studii, pentru a vă stăpâni cărțile`,
features: `Caracteristici`,
ratings: `Evaluări`,
notificationDailyCatchUpBody: `Nou: __, Due: ___, Studierea: ____, învățat: _____, stăpânit: ______`,
notificationDailyCatchUpTitle: `Captură zilnică`,
reviewedJN: `Revizuit chiar acum`,
customUpdated: `Text personalizat actualizat`,
customTextField: `Sinonime, exemple etc.`,
field: `Camp`,
link: `Legătură`,
backToParentCard: `Înapoi la cardul părinte`,
discard: `Aruncat`,
failedImageLoad: `Nu a reușit să încarce imaginea, asigurați -vă că sunteți conectat la Internet`,
printDIYLabel: `DIY propriul dvs. configurație de studiu bazat pe hârtie creativă, împărtășiți -vă cu noi creația dvs. și obțineți -vă în aplicație.`,
reviewGraphChart: `Frecvența de revizuire`,
langNotSet: `Limbajul nu este setat`,
pronouncationLangInfo: `Pentru a activa pronunția, trebuie să selectați termenul și limbajul de definiție. Un semn de difuzor va apărea lângă limbi dacă dispozitivul dvs. acceptă această limbă`,
clearFilters: `Filtru clar`,
subFreeUnlimited: `Studyset -uri nelimitate, carduri flash, practici, căutare și sincronizare`,
customFields: `câmpuri customizate`,
subLinks: `Link -uri de card`,
subPrint: `Tipărire / Studyset`,
subNotifications: `Notificare înainte de a deschide aplicația`,
subCardsStudysets: `Cărți / studyset`,
subRevisionCycles: `Cicluri de revizuire personalizate`,
subscriptionHEnd: `Actualizarea la Pro ne arată că vă considerați munca grea valoroasă și ne oferă încurajare și cafea pentru a continua să îmbunătățim și să creăm noi lucruri uimitoare.`,
subFree: `Liber`,
subPro: `Pro`,
guideSpacedRepetition: `Cum funcționează repetiția distanțată de lucru și de practică`,
guideSearch: `Căutare și filtrare`,
guideSync: `Activați backup și sincronizare pe dispozitivele dvs.`,
guidePronunciation: `Activați pronunțiile`,
guideImport: `Importarea cardurilor din surse din ieșire`,
guideAccess: `Cine are acces la datele mele?`,
guideData: `Ce date colectăm?`,
guideContact: `Aveți nevoie de ajutor cu altceva? Scrie-ne`,
arrowStrength: `Setați cât de bine știți acest card`,
arrowImage: `Adăugați imagini`,
arrowField: `Adăugați câmpuri de text personalizate suplimentare`,
arrowTag: `Atașați etichete`,
arrowStar: `Mark ca favorit`,
arrowLink: `Link către alte cărți`,
arrowGoal: `Stabiliți un obiectiv de revizuire zilnic pentru dvs.`,
arrowDue: `Cuvinte de studiu care urmează să fie revizuite`,
arrowNew: `Cărți de studiu care nu au fost încă revizuite`,
arrowMastered: `Dacă nu aveți carduri datorate sau noi, puteți examina cardurile master pentru a le păstra stăpânite`,
arrowImport: `Importați carduri flash existente`,
arrowNewCard: `Adăugați un nou flashcards`,
dropboxStep1: `1. Obțineți codul de acces de la Dropbox prin conectarea`,
dropboxStep1Btn: `Conectați -vă cu Dropbox`,
dropboxStep2: `2. Introduceți codul de acces mai jos`,
dropboxStep2Input: `Introdu codul aici`,
dropboxStep3: `3. Porniți sincronizarea`,
alreadyLinked: `Deja legat, atingeți pentru a dezlipi`,
selectCardsToLink: `Selectați carduri pentru a face legătura`,
unsupportedLangP: `Selectați un limbaj care acceptă pronunțarea din setările setului`,
links: `Link -uri`,
emailUs: `Trimite-ne un e-mail`,
whatsappUs: `Whatsapp nostru`,
printMinHeight: `Min. înălțimea rândului`,
exportType: `Tip de fișier de export`,
generateFileText: `Generați fișier`,
generatatingFile: `Generarea fișierului`,
verySmall: `Foarte mic`,
small: `Mic`,
normal: `Normal`,
big: `Mare`,
veryBig: `Foarte mare`,
repeatNTimes: `Repetați __ ori`,
pause: `Pauză`,
for: `pentru`,
say: `Spune`,
defShort: `Defini.`,
times: `ori`,
autoplayPreferences: `Setați preferințele Autoplay`,
autoPlay1: `Pauză după cuvântul anterior`,
autoPlay2: `Numărul de pronunții pe termen`,
autoPlay3: `Pauză înainte de a dezvălui definiția`,
autoPlay4: `Numărul de declarații de definiție`,
autoPlay5: `Pauză înainte de a arăta următorul cuvânt`,
autoPlay6: `Repetați același flashcard`,
startAutoPlay: `Porniți automat`,
autoPlayOffConfirm: `Opriți Autoplay pentru a activa controalele manuale`,
turnOff: `Opriți`,
keepPn: `Continua`,
foundIn: `Gasit in __`,
repeat: `repeta`,
stop: `Stop`,
listenInBreak: `Știați? Puteți asculta muzică / podcast -uri în pauze`,
contextSearch: `Căutare în context`,
contextSearchText: `Obțineți exemple despre modul în care __ utilizat în diferite propoziții`,
transalteSearch: `Traduceți`,
translateSearchText: `Tradu in ___`,
synonymSearch: `Căutare sinonimă`,
synonymSearchText: `Căutați sinonime de __`,
selectToAdd: `Selectați rezultatele pe care doriți să le adăugați la acest card`,
addToCard: `Adăugați selectat pe card`,
hideFromPractice: `Ascunde în rundă`,
setLanguageRequired: `Vă rugăm să selectați limba Termenii și definițiile din detaliile StudySet`,
fieldNeedsText: `Introduceți ceva în acest câmp înainte de a căuta`,
possibleDupe: `Posibil duplicat`,
loadNextXCards: `Încărcați __ cărți`,
repeatPractice: `Repetați aceste __ cărți`,
keepScreenOnInfo: `S-ar putea să fie nevoit să vă ajustați setarea automatului, pentru a menține ecranul pornit în timp ce auto-automat.`,
siteLoginH2: `Cont SFM`,
siteLoginP: `Puteți utiliza cardurile dvs. Flash Made Simple pentru a împărtăși carduri flash cu prietenii, studenții sau întreaga comunitate.`,
logOut: `Deconectați -vă`,
logIn: `Autentificare`,
createAccount: `Creează un cont nou`,
signUp: `Inscrie-te`,
username: `Nume de utilizator`,
email: `E-mail`,
password: `Parola`,
networkError: `Eroare de rețea`,
fillAllDetails: `Vă rugăm să completați toate detaliile`,
noUserWithDetails: `Niciun utilizator nu a fost găsit cu detaliile introduse`,
userAlreadyExists: `E -mailul sau numele de utilizator dat există deja`,
signUpOrLoginToCont: `Înscrieți -vă sau conectați -vă pentru a continua?`,
atLeastOneCardToShare: `Cel puțin o carte este necesară pentru a partaja`,
publishingStudyset: `Publicare Studyset`,
updatesDetected: `Actualizări detectate, doriți să continuați actualizarea datelor locale? (Șters: __, actualizat: ___, nou: ____)`,
updatesApplied: `Actualizări aplicate`,
alreadyUpToDate: `Deja la zi`,
practiceTypeArrow: `Descoperiți diferite moduri de a face parte`,
share: `Acțiune`,
sharingModalIntro: `Împărtășește -ți carduri flash în acest set cu prietenii, studenții sau întreaga comunitate.`,
whatIsShared: `Ce este împărtășit`,
whatIsNotShared: `Ce nu este împărtășit`,
whatIsSharedText: `Setați numele, setați limbajul termenului, limbajul definitiv, toate cardurile incluse cu termeni, definiții, câmpuri de text personalizate și imagini`,
whatIsNotSharedText: `Orice puncte forte, stele, link -uri, etichete și istoricul recenziei dvs.`,
checkForSharedUpdates: `Verificați actualizări de la Creator`,
fetchUpdates: `Pregătiți actualizări`,
youSharedStudyset: `Ai împărtășit acest studyset`,
publishChanges: `Salvați și publicați modificări`,
redeem: `Răscumpăra`,
noAds: `Fără reclame`,
dupeDetection: `Detectarea duplicată`,
coffeeFeature: `Cafea, pentru a ne ajuta să dezvoltăm mai multe caracteristici`,
shareLink: `Imparte link-ul`,
coffeeForUs: `Veți primi o licență pe viață doar pentru __, ceea ce oferă Emily 6 cafele, cafenele Dominik 3 și cafenele Russ 3, care ne vor alimenta timp de aproximativ 39 de ore pentru a îmbunătăți acest eveniment de aplicație`,
sharingCards: `Partajarea cărților`,
published: `Publicat`,
alreadyHaveAccount: `ai deja un cont?`,
notAlreadyHaveAccount: `Nu aveți încă un cont?`,
startPractice: `Începe practica`,
selectQuizTypes: `Selectați tipuri de testare`,
correct: `Corect`,
incorrect: `Incorect`,
yes: `da`,
no: `Nu`,
levelSilver: `Nivel de argint __`,
levelGold: `Nivel de aur __`,
levelPlatinum: `Nivel de platină __`,
levelDiamond: `Nivel de diamant __`,
levelJade: `Nivel de jad __`,
reviewsLeftGoal: `__ Recenzii pentru obiectivul zilnic`,
dailyGoalAchieved: `Obiectivul zilnic atins`,
share: `Acțiune`,
rateApp: `Aplicație de evaluare`,
allStats: `Toate statisticile`,
reviewTimeError: `Timeout după eroare`,
reviewTimeCorrect: `Timeout după corect`,
pronounceTermAfterReview: `Pronunță termen după revizuire`,
pronounceDefinitionAfterReview: `Definiție pronunțată după recenzie`,
practice: `Practică`,
notificationsScheduledInfo: `__ Notificări au fost programate, puteți închide aplicația acum`,
wellDone: `Foarte bine`,
keepItUp: `Ține-o așa`,
youRock: `Esti tare`,
niceOne: `Frumos`,
lnSelect: `Selecteaza limba`,
sampleData: `Fără recenzii, care arată datele eșantionului`,
reviewFreq: `Frecvența de revizuire`,
selectPractice: `Practică: Selectați`,
spellPractice: `Practică: vraja`,
connectPractice: `Practică: Conectați -vă`,
languages: `Limbi`,
languagesPairs: `Perechi de limbă`,
shareArrow: `Partajați set cu prietenii, studenții sau întreaga comunitate`,
cardsPerRound: `Cărți / rotundă`,
showAll: `Arata tot`,
supportedLangsVary: `Limbile acceptate variază`,
practiceWithoutSave: `Practica nu este salvată`,
practiceWithoutSaveBody: `Nu ați adăugat acest Studyset în colecția dvs., doriți să îl adăugați acum pentru a vă salva progresul studiului?`,
saveSetNow: `Salvați cărți pentru colecția dvs.`,
continueWithoutSaveSave: `Începeți practica fără salvare`,
createdBy: `Creat de`,
setSavedToYourCollection: `Set de studiu salvat în colecția dvs.`,
accountBackupDisclaimer: `Vă rugăm să rețineți că acest cont poate fi utilizat doar pentru partajarea studiilor cu alții și nu poate fi utilizat pentru a face backup sau sincronizarea studiilor sau a cardurilor flash. Pentru a sincroniza și face backup toate datele dvs., vă rugăm să utilizați Dropbox Sync`,
syncEnabled: `Sincronizare activată, aducând conținutul dvs. în curs`,
searchAllSets: `Seturi de studiu de căutare de la alți utilizatori`,
anyLanguage: `Orice limbă`,
trendingIn: `Trending în`,
manualBackups: `Backup manual`,
manualBackupCreate: `Creați o copie de rezervă manuală`,
confirmManualImport: `Sunteți sigur că doriți să înlocuiți toate datele curente cu această copie de rezervă? Acest lucru este recomandat doar pe dispozitive noi, fără date`,
importFromManualBackup: `Import din backup`,
imgOfflineSets: `Imagini de descărcare automată pentru învățare offline`,
unsupportedDeviceCache: `Această caracteristică este disponibilă numai din aplicația iOS sau Android`,
shareChanges: `Împărtășește __ modificări`,
publiclySearchable: `Căută de utilizatori`,
description: `Descriere`,
restoreFromDropboxBackup: `Restaurați din backup -ul Dropbox`,
imageCacheStudysetSub: `[doar iOS și Android] Descărcați imaginea pentru studierea offline`,
keywordsOrLangNeeded: `Trebuie să introduceți câteva cuvinte cheie sau o limbă`,
dropboxAlreadyLinked: `Contul Dropbox este deja conectat`,
noSetUpdateAccess: `Nu aveți acces pentru a edita acest set de studiu.`,
confirmSetOwnerLogin: `Dacă sunteți sigur că sunteți proprietarul, atunci încercați să vă conectați din nou la contul dvs.`,
uninitedRestriction: `Pentru a vă salva progresul, mai întâi trebuie să adăugați acest studyset în colecția dvs.`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Nu a reușit să consolideze stocarea`,
consolidateStorageDone: `Consolidarea stocării, vă rugăm să permiteți până la o oră pentru ca Dropbox să termine eliminarea fișierelor vechi înainte de a vă conecta pe un dispozitiv nou.`,
consolidatingStorage: `Consolidarea depozitării ...`,
deleteAccount: `Șterge cont`,
consolidateStorageDescription: `Această operație vă va redacta fișierele de rezervă, astfel încât configurarea unui nou dispozitive va fi mai rapidă`,
consolidatingStorageConfirm: `Asigurați -vă că toate modificările dvs. au terminat deja sincronizarea, nu sincronizați alte dispozitive în timp ce acest proces are loc. Doriți să continuați?`,
consolidateStorage: `Consolidarea stocării`,


}